/**
 * Name of the readable cookie that says "a session exists". The session cookie
 * itself is httpOnly, so a tab cannot see another tab sign in; this one carries
 * no secret and only lets the page notice the change without asking the API.
 * The API adds a `__Host-` prefix over https, so match by the end of the name.
 */
export const SIGNED_IN_FLAG = 'signed-in';
